module.exports = __webpack_public_path__ + "media/images/city/014-dprmpr-building-916159f45d6e863b4266ee98f3535f42.svg";